import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, DownloadService, RestService, UploadService } from '@saliente/common';
import { AuthService } from '@saliente/common-auth';
import { buildQueryParams, dateToInt, SpinnerService, UID } from '@saliente/library';
import { classToPlain, plainToClass } from 'class-transformer';
import gql from 'graphql-tag';
import { ToastrService } from 'ngx-toastr';
import { DialogCloseResult, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { catchError, debounceTime, filter, finalize, map, switchMap, take } from 'rxjs/operators';
import { HistoryChangeAddModel, HistoryChangeDeleteModel, HistoryChangeModel, HistoryFieldModel, HistoryModel } from 'src/app/payroll/general-history-grid/history.models';
import { SuspendareModel, TerminareModel } from '../common/payroll.models';
import { AngajatAttachmentModel, CertificateType, ChangeEmployeeSalaryModel, CityModel, CoasiguratModel, CountyModel, DeducereModel, EmployeeCertificateInputModel, EmployeeDetailsModel, EmployeeDocumentAvailability, EmployeeListModel, EmployeeModel, EmployeeTerminationModel, EmployeeCdaTerminationModel, EmployeeMandatTerminationModel, HandicapModel } from './employees.models';
import { GetNewOutDocNumberForClientGQL } from '../adapters/calculation.generated';


// need it form listSourceStream need in vehicle-edit.component
const employeesListSourceQueryText = gql`
query employeesListSource ($clientEid: String!){
	accounts {
		getPersonsForAccountingUsingGET(clientExternalId: $clientEid) {
			employeeExternalId
			ciDocumentNumber
			lastName
			firstName
			isActive
		}
	}
}`;

/* ------------------------------------------------------------------------------------------------------------ */

const dictionaryDefaultFieldsText = `
	id
	code
	display
`;

const dictionaryDefaultRegesFieldsText = `
	id
	code
	display
	codReges
`;

const statusAngajatFieldsText = `
	${dictionaryDefaultFieldsText}
	categorie
`;

const modelContractFieldsText = `
	${dictionaryDefaultFieldsText}
	permitePontaj
	utilizabilClient
	contractTypeGroup
`;

const coasiguratiFieldsText = `
	externalId
	clientEid
	tipCoasiguratId
	numeCoasigurat
	prenumeCoasigurat
	cnp
	deLa
	panaLa
	tipCoasigurat {
		${dictionaryDefaultFieldsText}
	}
`;

const deduceriFieldsText = `
	externalId
	clientEid
	persoanaInDeducere
	cnpPersoana
	tipDeducereId
	gradHandicapId
	deLa
	panaLa
	gradHandicap {
		${dictionaryDefaultFieldsText}
	}
	tipDeducere {
		${dictionaryDefaultFieldsText}
	}
`;

const handicapuriFieldsText = `
	externalId
	clientEid
	tipHandicapId
	gradHandicapId
	tipHandicapRegesId
	documentEid
	numarCertificatHandicap
	deLa
	panaLa
	activ
	tipHandicap {
		${dictionaryDefaultFieldsText}
	}
	gradHandicap {
		${dictionaryDefaultFieldsText}
	}
	tipHandicapReges {
		${dictionaryDefaultFieldsText}
	}
`;

const suspendariFieldsText = `
	motivSuspendareId
	deLa
	panaLa
	dataRevenire
	documentEid
	activ
	externalId
	clientEid
	motivSuspendare {
		${dictionaryDefaultFieldsText}
	}
`;

const angajatAttachmentsFieldsText = `
	fileType
	fileEid
	fileName
	fileSize
	displayOrder
`;

const employeeDetailsQueryText = gql`
query employeeDetails($clientEid: String!, $externalId: String!, $atDate: Int, $eom: Boolean){
	payroll {
		getEmployeeUsingGET(clientEid: $clientEid, externalId: $externalId, atDate: $atDate, eom: $eom) {
			initialaTata
			dataNasterii
			cis
			email
			telefon
			adresa
			judetId
			judetCod
			judetNume
			orasId
			orasNume
			taraCod
			taraNume
			banca
			iban
			cetatenieCod
			cetatenieNume
			localitateNastere
			serie
			numar
			eliberatDe
			valabilDeLa
			valabilPanaLa
			hasCNP
			hasNIF
			hasPassport
			dataPlecarii
			contractNo
			contractDate
			perioadaProba
			contractDocumentEid
			preavizDemisie
			preavizConcediere
			dataPlataAvans
			dataPlataLichidare
			obiectContract
			scurtaCaracterizarePost
			criteriiEvaluare
			tipDocumentPersonalId
			nume
			prenume
			cnp
			dataAngajarii
			tarifarIncadrare
			functieInterna
			siteEid
			siteName
			numarOre
			dataTerminarii
			functieBaza
			sporWeekend
			departament
			concediuOdihna
			concediuOdihnaSuplimentar
			scutitImpozitIt
			pensionar
			sexId
			casaSanatateId
			tipNormaId
			repartizareTipMuncaId
			durataContractId
			functieCorId
			conditiiMuncaId
			statusAngajatId
			modelContractId
			tipOreId
			tipSporWeekendId
			dataAsigurat
			deducereOug67
			oug16
			lunaPlataCenzor
			valoareSporWeekend
			copiiDeducereOug16100ron
			deducereOug16200ron
			pilonIiOptional
			tipNormaRegesId
			repartizareMuncaId
			detaliiRepartizareTimpMunca
			nivelStudiiId
			tipLocMuncaId
			tipTuraId
			judetLocMuncaId
			localitateLocMuncaId
			oraInceput
			oraSfarsit
			numarAutorizatie
			tipAutorizatieId
			tipAutorizatieExceptieId
			dataInceputAutorizatie
			dataSfarsitAutorizatie
			gradInvaliditateId
			externalId
			clientEid
			validat
			regesSalariatEid
			regesContractEid
			sex {
				${dictionaryDefaultFieldsText}
			}
			casaSanatate {
				${dictionaryDefaultFieldsText}
			}
			tipDocumentPersonal {
				${dictionaryDefaultFieldsText}
			}
			tipNorma {
				${dictionaryDefaultFieldsText}
			}
			repartizareTipMunca {
				${dictionaryDefaultFieldsText}
			}
			durataContract {
				${dictionaryDefaultFieldsText}
			}
			functieCor {
				${dictionaryDefaultFieldsText}
			}
			conditiiMunca {
				${dictionaryDefaultFieldsText}
			}
			statusAngajat {
				${statusAngajatFieldsText}
			}
			modelContract {
				${modelContractFieldsText}
			}
			tipOre {
				${dictionaryDefaultFieldsText}
			}
			tipSporWeekend {
				${dictionaryDefaultFieldsText}
			}
			tipNormaReges {
				${dictionaryDefaultRegesFieldsText}
			}
			repartizareMunca {
				${dictionaryDefaultRegesFieldsText}
			}
			nivelStudii {
				${dictionaryDefaultRegesFieldsText}
			}
			tipLocMunca {
				${dictionaryDefaultRegesFieldsText}
			}
			tipTura {
				${dictionaryDefaultRegesFieldsText}
			}
			judetLocMunca {
				id
				code
				display
			}
			localitateLocMunca {
				id
				codSiruta
				display
			}
			tipAutorizatie {
				${dictionaryDefaultRegesFieldsText}
			}
			tipAutorizatieExceptie {
				${dictionaryDefaultRegesFieldsText}
			}
			coasigurati {
				${coasiguratiFieldsText}
			}
			deduceri {
				${deduceriFieldsText}
			}
			handicapuri {
				${handicapuriFieldsText}
			}
			suspendari {
				${suspendariFieldsText}
			}
			angajatAttachments {
				${angajatAttachmentsFieldsText}
			}
			gradInvaliditate {
				${dictionaryDefaultFieldsText}
			}
		}
	}
}`;

const employeeListQueryText = gql`
query employeeList($clientEid: String!, $filter: String, $order: String, $offset: Int, $count: Int){
	payroll {
		getEmployeesUsingGET(clientEid: $clientEid, filter: $filter, order: $order, offset: $offset, count: $count) {
			recordsCount
			first
			last
			data {
				externalId
				cnp
				prenume
				nume
				contractNo
				contractDate
				siteName
				departament
				validat
				tarifarIncadrare
				minimumWage
				hasMinimumWage
				minimumWageYearsExceeded
				minimumWageDate
				hasSuspensionOrder
				anafSuspended
				tipLocMunca
				modelContract {
					${modelContractFieldsText}
				}
				statusAngajat {
					${statusAngajatFieldsText}
				}
			}
		}
	}
}`;


const insertEmployeeMutationText = gql`
mutation insertEmployee($clientEid: String!, $externalId: String!, $data: payroll_EmployeeRepresentationInput!){
	payroll {
		insertEmployeeUsingPUT(clientEid: $clientEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const invalidateEmployeeMutationText = gql`
mutation invalidateEmployee($clientEid: String!, $externalId: String!) {
	payroll {
		invalidateEmployeeUsingPUT(clientEid: $clientEid, externalId: $externalId) {
			Message
		}
	}
}`;

const insertGradHandicapMutationText = gql`
mutation insertGradHandicap($clientEid: String!, $employeeEid: String!, $externalId: String!, $data: payroll_HandicapRepresentationInput!){
	payroll {
		insertHandicapUsingPUT(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const deleteGradHandicapMutationText = gql`
mutation deleteGradHandicap($clientEid: String!, $employeeEid: String!, $externalId: String!){
	payroll {
		deleteHandicapUsingDELETE(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId) {
			Message
		}
	}
}`;

const insertCoasiguratMutationText = gql`
mutation insertCoasigurat($clientEid: String!, $employeeEid: String!, $externalId: String!, $data: payroll_CoasiguratRepresentationInput!){
	payroll {
		insertCoasiguratUsingPUT(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const deleteCoasiguratMutationText = gql`
mutation deleteCoasigurat($clientEid: String!, $employeeEid: String!, $externalId: String!){
	payroll {
		deleteCoasiguratUsingDELETE(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId) {
			Message
		}
	}
}`;

const insertDeducereMutationText = gql`
mutation insertDeducere($clientEid: String!, $employeeEid: String!, $externalId: String!, $data: payroll_DeducereRepresentationInput!){
	payroll {
		insertDeducereUsingPUT(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const deleteDeducereMutationText = gql`
mutation deleteDeducere($clientEid: String!, $employeeEid: String!, $externalId: String!){
	payroll {
		deleteDeducereUsingDELETE(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId) {
			Message
		}
	}
}`;

const insertSuspendareMutationText = gql`
mutation insertSuspendare($clientEid: String!, $employeeEid: String!, $externalId: String!, $data: payroll_SuspendareEmployeeRepresentationInput!){
	payroll {
		insertSuspendareUsingPUT(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const revenireSuspendareMutationText = gql`
mutation revenireSuspendare($clientEid: String!, $employeeEid: String!, $externalId: String!, $data: payroll_SuspendareRevenireRepresentationInput!){
	payroll {
		revenireSuspendareUsingPUT(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId, data: $data) {
			externalId
		}
	}
}`;

const deleteSuspendareMutationText = gql`
mutation deleteSuspendare($clientEid: String!, $employeeEid: String!, $externalId: String!){
	payroll {
		deleteSuspendareUsingDELETE(clientEid: $clientEid, employeeEid: $employeeEid, externalId: $externalId) {
			Message
		}
	}
}`;

const insertTerminareMutationText = gql`
mutation insertTerminare($clientEid: String!, $data: payroll_EmployeeStatusChangeRepresentationInput!){
	payroll {
		terminateEmployeeUsingPUT(clientEid: $clientEid, data: $data) {
			Message
		}
	}
}`;

const reactivateEmployeMutationText = gql`
mutation reactivateEmployee($clientEid: String!, $externalId: String!, $data: payroll_EmployeeStatusChangeRepresentationInput!){
	payroll {
		reactivateEmployeeUsingPOST(clientEid: $clientEid, externalId: $externalId, data: $data) {
			Message
		}
	}
}`;

const cancelEmployeeTerminationMutationText = gql`
mutation cancelEmployeeTermination($clientEid: String!, $externalId: String!, $data: payroll_EmployeeStatusChangeRepresentationInput!){
	payroll {
		cancelEmployeeTerminationUsingPOST(clientEid: $clientEid, externalId: $externalId, data: $data) {
			Message
		}
	}
}`;

const removeEmployeeMutationText = gql`
mutation removeEmployee($clientEid: String!, $employeeEid: String!){
	payroll {
		removeEmployeeUsingDELETE(clientEid: $clientEid, employeeEid: $employeeEid) {
			Message
		}
	}
}`;

const validatePersonEmployeeMutationText = gql`
mutation validatePersonEmployee($clientEid: String!, $externalId: String!){
	payroll {
		validateEmployeeUsingPUT(clientEid: $clientEid, externalId: $externalId) {
			clientEid
			cnp
			infoMsg
		}
	}
}`;

const clientCaenQueryText = gql`
query clientCaen($clientEid: String, $atDate: Int) {
	accounts {
		GetClientUsingGET(clientEid: $clientEid, atDate: $atDate) {
			sysCaenCode {
				code
				description
			}
		}
	}
}`;

const getCountiesQueryText = gql`
query getCounties {
	payroll {
		getCountiesUsingGET {
			id
			code
			display
		}
	}
}`;

const getCitiesByCountyQueryText = gql`
query getCities($countyCode: String) {
	payroll {
		getCitiesByCountyUsingGET(countyCode: $countyCode) {
			id
			codSiruta
			display
			county {
				id
				code
				display
			}
		}
	}
}`;

const getRegesBlockStatusQueryText = gql`
query getBlockStatus($clientEid: String!, $cnp: String!) {
	payroll {
		getBlockStatusUsingGET(clientEid: $clientEid, cnp: $cnp) {
			cnp
			clientEid
			blockedAt
			blockedByUserName
		}
	}
}`;

const isRegesSyncBlockedQueryText = gql`
query isRegesSyncBlocked($clientEid: String!, $cnp: String!) {
	payroll {
		isRegesSyncBlockedUsingGET(clientEid: $clientEid, cnp: $cnp)
	}
}`;

const getClientPayrollTypeQueryText = gql`
query getClientPayrollType($clientEid: String!) {
	accounts {
		getSuperExpertProgressManagementPayrollStatusUsingGET(clientEid: $clientEid) {
			payrollType
		}
	}
}`;

const blockCnpMutationText = gql`
mutation blockCnp($clientEid: String!, $cnp: String!) {
	payroll {
		blockCnpUsingPOST(clientEid: $clientEid, cnp: $cnp) {
			Message
		}
	}
}`;

const unblockCnpMutationText = gql`
mutation unblockCnp($clientEid: String!, $cnp: String!) {
	payroll {
		unblockCnpUsingDELETE(clientEid: $clientEid, cnp: $cnp) {
			Message
		}
	}
}`;

const importRegesLinksMutationText = gql`
mutation importRegesLinks($clientFiscalNumber: String!, $request: payroll_RegesImportRequestRepresentationInput!) {
	payroll {
		importRegesLinksUsingPOST(clientFiscalNumber: $clientFiscalNumber, request: $request) {
			inserted
			updated
			skipped
			errors
			warnings
		}
	}
}`;

@Injectable({
	providedIn: 'root'
})
export class EmployeesService {

	private sortStream = new BehaviorSubject<string>('contractDate asc');
	private filtersStream = new BehaviorSubject<string>(null);
	private pageSizeStream = new BehaviorSubject<number>(20);
	public pageIndexStream = new BehaviorSubject<number>(0);
	public currentListModel : EmployeeListModel;

	get filters() {
		return this.filtersStream.value;
	}
	set filters(value: string) {
		this.filtersStream.next(value);
	}

	get pageSize() {
		return this.pageSizeStream.value;
	}
	set pageSize(value: number) {
		this.pageSizeStream.next(value);
	}

	get pageIndex() {
		return this.pageIndexStream.value;
	}
	set pageIndex(value: number) {
		this.pageIndexStream.next(value);
	}

	constructor(private authService: AuthService, private restService: RestService, private configService: ConfigService, private uploadService: UploadService,
		private spinner: SpinnerService, private downloadService: DownloadService, private http: HttpClient, private toastr: ToastrService,
		private dialogService: DialogService) { }

	// need it in vehicle-edit.component
	public listSourceStream(clientEid: string, onlyActive: boolean = false): Observable<any[]> {
		var self = this,
			stream = function (clientEid: string) {
				return self.restService
					.query({
						query: employeesListSourceQueryText,
						variables: { clientEid: clientEid },
						fetchPolicy: 'network-only'
					})
					.pipe(
						map((res: any) => {
							if (res) {
								const employees = JSON.parse(JSON.stringify(res.data.accounts.getPersonsForAccountingUsingGET));
								employees.forEach((employee: any) => {
									employee.name = `${employee.lastName} ${employee.firstName}`;
								});
								if (onlyActive) {
									return employees.filter((e: any) => e.isActive);
								}
								return employees;
							} else {
								return [];
							}
						})
					);
			}
		if (!clientEid) {
			return self.authService.getSelectedCompanyId()
				.pipe(
					switchMap((companyId) => {
						return stream(companyId);
					})
				);
		}
		return stream(clientEid);
	}

	/* ------------------------------------------------------------------------------------------------------------ */
	/**
	* Employee list grid
	*/
	public fetchEmployeeList(debounce: number = 500): Observable<EmployeeListModel> {
		return combineLatest([this.authService.getSelectedCompanyId(), this.filtersStream, this.sortStream, this.pageSizeStream, this.pageIndexStream])
			.pipe(
				debounceTime(debounce),
				switchMap(([clientEid, filter, sort, pageSize, pageIndex]) => {
					if (clientEid) {
						return this.restService
							.query({
								query: employeeListQueryText,
								variables: {
									clientEid: clientEid,
									filter,
									order: sort,
									offset: pageIndex * pageSize,
									count: pageSize
								},
								fetchPolicy: 'network-only'
							})
							.pipe(
								map((response: any) => {
									let result: EmployeeListModel = null;
									try {
										result = plainToClass(EmployeeListModel, response.data.payroll.getEmployeesUsingGET);
										result.data = plainToClass<EmployeeModel, object>(EmployeeModel, result.data || []);

										result.data.forEach((res, index) => {
											res.displayIndex = result.first + index + 1;
										});

									} catch {
										result = null;
									}
									this.currentListModel = result;
									return result;
								})
							);
					}
					return of(null);
				})
			);
	}

	public fetchAllEmployeeList(): Observable<EmployeeListModel> {
		if (this.authService.user.selectedCompanyId == null)
			return;
		
		return this.restService
			.query({
				query: employeeListQueryText,
				variables: { clientEid: this.authService.user.selectedCompanyId, filter: null, order: null, offset: null, count: null },
				fetchPolicy: 'network-only'
			},
			{ spinner: false, error: false })
			.pipe(
				map((response: any) => {
					let result: EmployeeListModel = null;
					try {
						result = plainToClass(EmployeeListModel, response.data.payroll.getEmployeesUsingGET);
					} catch {
						result = null;
					}
					return result;
				})
			);
	}

	public filter(filter: string) {
		const self = this;
		self.pageIndexStream.next(0);
		self.filtersStream.next(filter);
	}

	public sort(sort: string) {
		if (this.sortStream.value != sort) {
			this.sortStream.next(sort);
		}
	}


	/**
	* Employee details
	*/
	public fetchEmployeeDetails(externalId: string, spinner: boolean = true): Observable<EmployeeDetailsModel> {
		return this.restService
			.query({
				query: employeeDetailsQueryText,
				variables: { 
					clientEid: this.authService.user.selectedCompanyId, 
					externalId,
					atDate: dateToInt(new Date())
				},
				fetchPolicy: 'network-only'
			}, { spinner: spinner })
			.pipe(
				map((response: any) => {
					if (response) {
						let personEmployeeModel: EmployeeDetailsModel = null;
						try {
							personEmployeeModel = plainToClass(EmployeeDetailsModel, response.data.payroll.getEmployeeUsingGET);
						} catch {
							personEmployeeModel = null;
						}
						return personEmployeeModel;
					}
					return null;
				})
			);
	}

	public invalidateEmployee(model: EmployeeDetailsModel) {
		return this.restService
			.mutate({
				mutation: invalidateEmployeeMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					externalId: model.externalId
				}
			}, { spinner: true })
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public insertOrUpdatePersonEmployee(model: EmployeeDetailsModel, spinner: boolean) {
		return this.restService
			.mutate({
				mutation: insertEmployeeMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					externalId: model.externalId,
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			}, { spinner: spinner })
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.insertEmployeeUsingPUT.externalId;
					}
					return null;
				})
			);
	}

	public getCompanySites() {
		return combineLatest([this.authService.getSelectedCompanyId(), this.configService.getPayrollUrl()])
			.pipe(
				switchMap(([clientEid, resultUrl]) => {
					let headers = new HttpHeaders();
					headers = headers.append('authorization', this.authService.authHeaderValue());
					headers = headers.append('Content-Type', "application/json");

					let params = {
						clientEid: clientEid,
					};
			
					let queryParams = buildQueryParams(params); 
		
					return this.http
						.get(`${resultUrl}/dictionaries/sys_sites`, {
							headers,
							params: queryParams
						})
						.pipe(
							map((response: any) => {
								return response;
							}),
							catchError((err: any) => {
								return of(null);
							}),
							finalize(() => {
							})
						)
				})
			);
	}

	public getDocumentsAvailability(employeeIds: string[]): Observable<EmployeeDocumentAvailability[]> {
		return combineLatest([this.authService.getSelectedCompanyId(), this.configService.getPayrollUrl()])
			.pipe(
				switchMap(([clientEid, resultUrl]) => {
					let headers = new HttpHeaders();
					headers = headers.append('authorization', this.authService.authHeaderValue());
					headers = headers.append('Content-Type', "application/json");

					return this.http
						.post(`${resultUrl}/clients/${clientEid}/employees/documents-availability`, employeeIds, {
							headers
						})
						.pipe(
							map((response: any) => {
								return response != null ? response.documents as EmployeeDocumentAvailability[] : null;
							}),
							catchError((err: any) => {
								return of(null);
							})
						)
				})
			);
	}

	public validatePersonEmployee(model: EmployeeDetailsModel) {
		return this.restService
			.mutate({
				mutation: validatePersonEmployeeMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					externalId: model.externalId,
				}
			})
			.pipe(
				map((response) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public generateContract(employeeIds: string[]) {
		let clientEid = this.authService.user.selectedCompanyId;
		return this.configService
			.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/clients/${clientEid}/employees/generate/contract`;
					return this.downloadService.downloadUsingPost(url, employeeIds);
				}),
				take(1)
			)
			.subscribe();
	}

	public generateModificareContract(data: ChangeEmployeeSalaryModel[]): Observable<string> {
		let clientEid = this.authService.user.selectedCompanyId;
		return this.configService.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/clients/${clientEid}/employees/generate/salary`;
					return this.downloadService.downloadUsingPost(url, classToPlain(data, { excludePrefixes: ['__'] }));
				})
			);
	}

	public generateDemisieAcordParti(data: EmployeeTerminationModel[]): Observable<string> {
		let clientEid = this.authService.user.selectedCompanyId;
		return this.configService.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/clients/${clientEid}/employees/generate/termination`;
					return this.downloadService.downloadUsingPost(url, classToPlain(data, { excludePrefixes: ['__'] }));
				})
			);
	}

	public generateDecizieIncetareCda(data: EmployeeCdaTerminationModel[]): Observable<string> {
		let clientEid = this.authService.user.selectedCompanyId;
		return this.configService.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/clients/${clientEid}/employees/generate/termination-cda?downloadType=pdf`;
					return this.downloadService.downloadUsingPost(url, classToPlain(data, { excludePrefixes: ['__'] }));
				})
			);
	}

	public generateTerminationMandat(data: EmployeeMandatTerminationModel[]): Observable<string> {
		let clientEid = this.authService.user.selectedCompanyId;
		return this.configService.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/clients/${clientEid}/employees/generate/termination-mandat?downloadType=pdf`;
					return this.downloadService.downloadUsingPost(url, classToPlain(data, { excludePrefixes: ['__'] }));
				})
			);
	}

	public generateAdeverinta(data: EmployeeCertificateInputModel[]): Observable<any> {
		let clientEid = this.authService.user.selectedCompanyId;
		let downloadType = data[0].documentType;
		let certificateType = data[0].certificateType;

		return this.configService.getPayrollUrl()
			.pipe(
				switchMap((url) => {
					if (certificateType === CertificateType.SAL) {
						url = url + `/clients/${clientEid}/employees/generate/employement-certificate?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.CM) {
						url = url + `/clients/${clientEid}/employees/generate/employement-certificate-sick-leave?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.CIC) {
						url = url + `/clients/${clientEid}/employees/generate/employment-certificate-cic?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.STAG) {
						url = url + `/clients/${clientEid}/employees/generate/employment-certificate-stagiu?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.SAL_MND) {
						url = url + `/clients/${clientEid}/employees/generate/mandate-certificate?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.CM_MND) {
						url = url + `/clients/${clientEid}/employees/generate/mandate-certificate-sick-leave?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.CIC_MND) {
						url = url + `/clients/${clientEid}/employees/generate/mandate-certificate-cic?downloadType=${downloadType}`;
					}
					if (certificateType === CertificateType.STAG_MND) {
						url = url + `/clients/${clientEid}/employees/generate/mandate-certificate-stagiu?downloadType=${downloadType}`;
					}

					return this.downloadService.downloadUsingPost(url, classToPlain(data, { excludePrefixes: ['__'] }), true)
						.pipe(
							map((response) => {
								return response;
							}),
							catchError((postError) => {
								if (postError.errors != null) {
									let errorFound = postError.errors.find((err: any) => err.code === 'ERROR_OUT_DOC_NUMBER_TAKEN')
									if (errorFound != null) {
										return of(errorFound);
									}
								}
								this.handleGenerateAdeverintaErrors(postError);
								return of(null);
						})
					);
				})
			);
	}

	public handleGenerateAdeverintaErrors(postError: any) {
		let errorMessages: string[] = [];
		let message = postError.Message as string;
		if (postError.errors != null) {
			for (const err of postError.errors) {
				errorMessages.push(err.message);
			}
			this.restService.displayErrors(errorMessages);
		}
		else {
			this.toastr.error(message);
		}
	}

	public downloadAttachment(fileEid: string) {
		return this.configService
			.getDocumentsDownloadUrl()
			.pipe(
				switchMap((url) => {
					url = url + `/storage/${fileEid}`;
					return this.downloadService.download(url);
				}),
				take(1)
			)
			.subscribe();
	}

	public uploadFile(employeeEid: string, file: File, spinner: boolean = true): Observable<string> {
		spinner && this.spinner.show();

		let fileEid = UID();
		const meta = {
			clientEid: this.authService.user.selectedCompanyId,
			angajatEid: employeeEid,
			category: 'AngajatAttachment',
			fileEid
		};
		return this.configService
			.getDocumentsUploadUrl()
			.pipe(
				switchMap((url) => this.uploadService.upload(url + '/files', file, meta)),
				filter((data) => !!data.done),
				map((data) => {
					return fileEid;
				}),
				finalize(() => {
					spinner && this.spinner.hide();
				})
			);
	}

	public uploadFileStream(employeeEid: string, file: File): Observable<AngajatAttachmentModel> {
		return this.uploadFile(employeeEid, file)
			.pipe(
				map((fileEid: string) => {
					if (fileEid) {
						let newAttachment = this.createAttachment(fileEid, file);
						return newAttachment;
					}
					return null;
				})
			);
	}

	private createAttachment(fileEid: string, file: File) {
		let newAttachment = new AngajatAttachmentModel();
		newAttachment.fileEid = fileEid;
		newAttachment.fileName = file.name;
		newAttachment.fileSize = file.size;
		newAttachment.fileType = "CI";
		
		return newAttachment;
	}


	/**
	* Grids: Handicap, Coasigurat, Deducere
	*/
	public insertOrUpdateGradHandicap(employeeId: string, model: HandicapModel) {
		return this.restService
			.mutate({
				mutation: insertGradHandicapMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: model.externalId != null ? model.externalId : UID(),
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.insertHandicapUsingPUT.externalId;
					}
					return null;
				})
			);
	}

	public deleteGradHandicap(employeeId: string, gradHandicalExternalId: string) {
		return this.restService
			.mutate({
				mutation: deleteGradHandicapMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: gradHandicalExternalId
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public insertOrUpdateCoasigurat(employeeId: string, model: CoasiguratModel) {
		return this.restService
			.mutate({
				mutation: insertCoasiguratMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: model.externalId != null ? model.externalId : UID(),
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.insertCoasiguratUsingPUT.externalId;
					}
					return null;
				})
			);
	}

	public deleteCoasigurat(employeeId: string, coasiguratExternalId: string) {
		return this.restService
			.mutate({
				mutation: deleteCoasiguratMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: coasiguratExternalId
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public insertOrUpdateDeducere(employeeId: string, model: DeducereModel) {
		return this.restService
			.mutate({
				mutation: insertDeducereMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: model.externalId != null ? model.externalId : UID(),
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.insertDeducereUsingPUT.externalId;
					}
					return null;
				})
			);
	}

	public deleteDeducere(employeeId: string, deducereExternalId: string) {
		return this.restService
			.mutate({
				mutation: deleteDeducereMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: deducereExternalId
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public insertOrUpdateSuspendare(employeeId: string, model: SuspendareModel) {
		return this.restService
			.mutate({
				mutation: insertSuspendareMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: model.externalId != null ? model.externalId : UID(),
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.insertSuspendareUsingPUT.externalId;
					}
					return null;
				})
			);
	}


	public revenireSuspendare(employeeId: string, suspendareExternalId: string, dataRevenire: number) {
		return this.restService
			.mutate({
				mutation: revenireSuspendareMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: suspendareExternalId,
					data: { dataRevenire: dataRevenire }
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.revenireSuspendareUsingPUT.externalId;
					}
					return null;
				})
			);
	}

	public deleteSuspendare(employeeId: string, suspendareExternalId: string) {
		return this.restService
			.mutate({
				mutation: deleteSuspendareMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId,
					externalId: suspendareExternalId
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	/**
	* Actions
	*/
	public removeEmployee(employeeId: string, ) {
		return this.restService
			.mutate({
				mutation: removeEmployeeMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					employeeEid: employeeId
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public insertTerminare(model: TerminareModel) {
		return this.restService
			.mutate({
				mutation: insertTerminareMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					data: classToPlain(model, { excludePrefixes: ["__"] })
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public reactivateContract(employeeId: string, data: { reactivateDate: number, reactivateReason: string, comment: string }) {
		return this.restService
			.mutate({
				mutation: reactivateEmployeMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					externalId: employeeId,
					data: data
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public cancelTermination(employeeId: string, data: { comment: string }) {
		return this.restService
			.mutate({
				mutation: cancelEmployeeTerminationMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					externalId: employeeId,
					data: data
				}
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				})
			);
	}

	public async getNewOutDocNumberForClient(): Promise<number> {
		let qry = new GetNewOutDocNumberForClientGQL(this.restService);
		let x = await qry.fetch(
			{
				clientEid: this.authService.user.selectedCompanyId,
			}
		).toPromise();

		if (x != null) {
			return x.data.payroll.getNewOutDocNumberForClientUsingGET.newDocNumber;
		}

		return null;
	}

	/**
	* Employee history
	*/
	public getEmployeeHistory(employeeExternalId: string, parameterName: string): Observable<any> {
		let sourceUrl = this.configService.payrollUrl;
		let clientEid = this.authService.user.selectedCompanyId;
        
		let headers = new HttpHeaders();
		headers = headers.append('authorization', this.authService.authHeaderValue());
		headers = headers.append('Content-Type', "application/json");

		this.spinner.show();
		return this.http
			.get(`${sourceUrl}/clients/history/${clientEid}/employees/${employeeExternalId}/${parameterName}`, {
				headers
			})
			.pipe(
				map((response: any) => {
					let model: HistoryModel;
					let fields: HistoryFieldModel[];
					let changes: HistoryChangeModel[];
					
					try {
						fields = plainToClass<HistoryFieldModel, object>(HistoryFieldModel, response.fields || []);
					} catch {
						fields = null;
					}
					try {
						changes = plainToClass<HistoryChangeModel, object>(HistoryChangeModel, response.changes || []);
					} catch{
						changes = null;
					}

					model = new HistoryModel(fields, changes, sourceUrl);
					
					return model;
				}),
				catchError((err: any) => {
					this.restService.handleError(err);
					return of(null);
				}),
				finalize(() => {
					this.spinner.hide();
				})
			);
	}

	public addEmployeeParameterHistory(employeeExternalId: string, historyChangeAddModel: HistoryChangeAddModel): Observable<boolean> {
		let sourceUrl = this.configService.payrollUrl;
		let clientEid = this.authService.user.selectedCompanyId;
		let body = JSON.stringify(classToPlain<HistoryChangeAddModel>(historyChangeAddModel, { excludePrefixes: ["__"] }));
		
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authService.authHeaderValue());
		headers = headers.append('Content-Type', "application/json");

		this.spinner.show();
		return this.http
			.post(`${sourceUrl}/clients/history/${clientEid}/employees/${employeeExternalId}`, body, {
				headers: headers
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				}),
				catchError((err: any) => {
					this.restService.handleError(err);
					return of(false);
				}),
				finalize(() => {
					this.spinner.hide();
				})
			);
	}

	public invalidateEmployeeHistoryChange(employeeExternalId: string, historyChangeDeleteModel?: HistoryChangeDeleteModel): Observable<boolean> {
		let sourceUrl = this.configService.payrollUrl;
		let clientEid = this.authService.user.selectedCompanyId;
		let body = JSON.stringify(classToPlain<HistoryChangeDeleteModel>(historyChangeDeleteModel, { excludePrefixes: ["__"] }));
		
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authService.authHeaderValue());
		headers = headers.set('Content-Type', "application/json");

		this.spinner.show();
		return this.http
			.request('DELETE', `${sourceUrl}/clients/history/${clientEid}/employees/${employeeExternalId}`, {
				body: body,
				headers: headers
			})
			.pipe(
				map((response: any) => {
					if (response) {
						return true;
					}
					return false;
				}),
				catchError((err: any) => {
					this.restService.handleError(err);
					return of(false);
				}),
				finalize(() => {
					this.spinner.hide();
				})
			);
	}

	public getClientCaenCodes(): Observable<any> {
		return this.restService
			.query({
				query: clientCaenQueryText,
				variables: { 
					clientEid: this.authService.user.selectedCompanyId, 
					atDate: dateToInt(new Date())
				},
				fetchPolicy: 'network-only'
			}, { spinner: false })
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.accounts.GetClientUsingGET.sysCaenCode;
					}
					return null;
				})
			);
	}

	public getCounties(): Observable<CountyModel[]> {
		return this.restService
			.query({
				query: getCountiesQueryText,
				fetchPolicy: 'network-only'
			}, { spinner: false })
			.pipe(
				map((response: any) => {
					if (response) {
						let counties: CountyModel[] = [];
						try {
							counties = plainToClass<CountyModel, object>(CountyModel, response.data.payroll.getCountiesUsingGET || []);
						} catch {
							counties = [];
						}

						return counties;
					}
					return [];
				})
			);
	}

	public getCitiesByCounty(countyCode: string): Observable<CityModel[]> {
		return this.restService
			.query({
				query: getCitiesByCountyQueryText,
				fetchPolicy: 'network-only',
				variables: { 
					countyCode: countyCode
				},
			}, { spinner: false })
			.pipe(
				map((response: any) => {
					if (response) {
						let cities: CityModel[] = [];
						try {
							cities = plainToClass<CityModel, object>(CityModel, response.data.payroll.getCitiesByCountyUsingGET || []); 
						} catch {
							cities = [];
						}

						return cities;
					}
					return [];
				})
			);
	}

	public getRegesBlockStatus(cnp: string): Observable<boolean> {
		return this.restService
			.query({
				query: isRegesSyncBlockedQueryText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					cnp: cnp
				},
				fetchPolicy: 'network-only'
			}, { spinner: false, error: false })
			.pipe(
				map((response: any) => {
					return !!response?.data?.payroll?.isRegesSyncBlockedUsingGET;
				}),
				catchError(() => {
					return of(false);
				})
			);
	}

	public getClientPayrollType(): Observable<string> {
		return this.restService
			.query({
				query: getClientPayrollTypeQueryText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId
				},
				fetchPolicy: 'network-only'
			}, { spinner: false, error: false })
			.pipe(
				map((response: any) => {
					return response?.data?.accounts?.getSuperExpertProgressManagementPayrollStatusUsingGET?.payrollType || null;
				}),
				catchError(() => {
					return of(null);
				})
			);
	}

	public blockRegesCnp(cnp: string): Observable<boolean> {
		return this.restService
			.mutate({
				mutation: blockCnpMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					cnp: cnp
				}
			}, { spinner: true })
			.pipe(
				map((response: any) => {
					return !!response;
				})
			);
	}

	public unblockRegesCnp(cnp: string): Observable<boolean> {
		return this.restService
			.mutate({
				mutation: unblockCnpMutationText,
				variables: {
					clientEid: this.authService.user.selectedCompanyId,
					cnp: cnp
				}
			}, { spinner: true })
			.pipe(
				map((response: any) => {
					return !!response;
				})
			);
	}

	public uploadTemporaryFile(file: File, spinner: boolean = true): Observable<string> {
		spinner && this.spinner.show();

		let fileEid = UID();
		const meta = {
			clientEid: this.authService.user.selectedCompanyId,
			category: 'temporary',
			fileEid
		};
		return this.configService
			.getDocumentsUploadUrl()
			.pipe(
				switchMap((url) => this.uploadService.upload(url + '/files', file, meta)),
				filter((data) => !!data.done),
				map((data) => {
					return fileEid;
				}),
				finalize(() => {
					spinner && this.spinner.hide();
				})
			);
	}

	public importRegesLinks(fileEids: string[]): Observable<any> {
		return this.restService
			.mutate({
				mutation: importRegesLinksMutationText,
				variables: {
					clientFiscalNumber: this.authService.user.selectedCompany.fiscalNumber,
					request: {
						fileEids: fileEids
					}
				}
			}, { spinner: true })
			.pipe(
				map((response: any) => {
					if (response) {
						return response.data.payroll.importRegesLinksUsingPOST;
					}
					return null;
				})
			);
	}

	public async createAdeverintaModel(certificateType: string): Promise<EmployeeCertificateInputModel> {
		let docNo;
		try {
			docNo = await this.getNewOutDocNumberForClient();
		}
		catch (e) {}

		const adeverintaModel = new EmployeeCertificateInputModel();
		adeverintaModel.certificateType = certificateType;
		adeverintaModel.docNo = docNo;
		adeverintaModel.today = dateToInt(new Date());

		if (certificateType === CertificateType.CM) {
			adeverintaModel.certificateTitle = "Adeverință concediu medical";
			adeverintaModel.hasPurpose = false;
		}

		if (certificateType === CertificateType.CIC) {
			adeverintaModel.certificateTitle = "Adeverință indemnizație creștere copil";
			adeverintaModel.hasPurpose = false;
		}

		if (certificateType === CertificateType.STAG) {
			adeverintaModel.certificateTitle = "Adeverință de salariat stagiu";
			adeverintaModel.hasPurpose = false;
			adeverintaModel.hasMonths = true;
		}

		if (certificateType === CertificateType.SAL) {
			adeverintaModel.certificateTitle = "Adeverință de salariat";
			adeverintaModel.hasPurpose = true;
		}

		if (certificateType === CertificateType.SAL_MND) {
			adeverintaModel.certificateTitle = "Adeverință de mandatar";
			adeverintaModel.hasPurpose = true;
		}

		if (certificateType === CertificateType.CM_MND) {
			adeverintaModel.certificateTitle = "Adeverință concediu medical mandat";
			adeverintaModel.hasPurpose = false;
		}

		if (certificateType === CertificateType.CIC_MND) {
			adeverintaModel.certificateTitle = "Adeverință indemnizație creștere copil mandat";
			adeverintaModel.hasPurpose = false;
		}

		if (certificateType === CertificateType.STAG_MND) {
			adeverintaModel.certificateTitle = "Adeverință de mandatar stagiu";
			adeverintaModel.hasPurpose = false;
			adeverintaModel.hasMonths = true;
		}

		return adeverintaModel;
	}

	public generateAdeverintaWithConfirmation(data: EmployeeCertificateInputModel[]): Observable<boolean> {
		return this.generateAdeverinta(data)
			.pipe(
				switchMap((result) => {
					if (result && result.code === 'ERROR_OUT_DOC_NUMBER_TAKEN') {
						const docNumbers = data.map((d) => d.docNo).join(', ');
						const dialog: DialogRef = this.dialogService.open({
							title: "Atenție!",
							content: data.length == 1
								? `A fost generat deja un document cu numarul ${docNumbers}.`
								: `A fost generat deja un document cu unul dintre numerele ${docNumbers}.`,
							actions: [{ text: "Continuă cu acest număr", themeColor: "primary", result: true, primary: true }, { text: "Anulează", themeColor: "base", result: false }],
							width: 350,
							height: 200,
							minWidth: 250,
						});

						return dialog.result.pipe(
							take(1),
							switchMap((dialogResult) => {
								if (dialogResult instanceof DialogCloseResult || !(dialogResult as any).primary) {
									return of(null);
								}

								data.forEach((d) => d.ignoreWarnings = true);
								return this.generateAdeverinta(data).pipe(map((retryResult) => retryResult != null));
							})
						);
					}

					return of(result != null);
				})
			);
	}

	public getRemainingVacationDays(employeeEid: string): Observable<number> {
		const anLuna = Math.floor(dateToInt(new Date()) / 100);
		return combineLatest([this.authService.getSelectedCompanyId(), this.configService.getPayrollUrl()])
			.pipe(
				take(1),
				switchMap(([clientEid, resultUrl]) => {
					let headers = new HttpHeaders();
					headers = headers.append('authorization', this.authService.authHeaderValue());
					headers = headers.append('Content-Type', "application/json");

					return this.http
						.get(`${resultUrl}/clients/${clientEid}/employees/${employeeEid}/sold-co/${anLuna}`, {
							headers
						})
						.pipe(
							map((response: any) => {
								return response != null && response.coRamasLuna != null ? Math.round(response.coRamasLuna) : null;
							}),
							catchError((err: any) => {
								return of(null);
							})
						)
				})
			);
	}
}
